<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container d-flex flex-column h-full">
          <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
          >
          </TopAppBar>
          <div class="flex-grow-1 scroll-y">
            <div class="pda-default">
              <div class="container pda-20">
                <div class="wrapper">
                  <!-- <label for="DocumentWhite">Document White</label>
                  <input
                    id="DocumentWhite"
                    type="text"
                    class="color"
                    value="#ffffff"
                  /> -->
                  <compact-picker1
                    v-model="documentWhite"
                    @input="updateDocumentWhite"
                    :color="documentWhite"
                    picker="chrome"
                    label="Document White"
                  />

                  <p class="t-color-white">Document White color</p>

                  <!-- <label for="Black">Black</label>
                  <input type="text" id="Black" class="color" value="#000000" /> -->
                  <!-- <compact-picker1
                    v-model="black"
                    @input="updateBlack"
                    :color="black"
                    picker="chrome"
                    label="Black"
                  />
                  <p class="t-color-black">Black color</p> -->

                   <compact-picker1
                    v-model="shadow1"
                    @input="updateShadow1"
                    :color="shadow1"
                    picker="chrome"
                    label="Shadow1"
                  />
                  <p class="t-color-Shadow1"></p>

                   <compact-picker1
                    v-model="shadow2"
                    @input="updateShadow2"
                    :color="shadow2"
                    picker="chrome"
                    label="Shadow2"
                  />
                  <p class="t-color-Shadow2"></p>

                  <compact-picker1
                    v-model="shadow3"
                    @input="updateShadow3"
                    :color="shadow3"
                    picker="chrome"
                    label="Shadow3"
                  />
                  <p class="t-color-Shadow3"></p>

                   <compact-picker1
                    v-model="contentsDim"
                    @input="updateContentsDim"
                    :color="contentsDim"
                    picker="chrome"
                    label="ContentsDim"
                  />
                  <p class="t-color-contentsdim"></p>


                  <!-- <label for="Primary">Primary</label>
                  <input
                    type="text"
                    id="Primary"
                    class="color"
                    v-model="primary"
                  /> -->
                  <compact-picker1
                    v-model="primary"
                    @input="updatePrimary"
                    :color="primary"
                    picker="chrome"
                    label="Primary"
                  />
                  <p class="t-color-primary">Primary color</p>

                  <!-- <label for="PrimaryInactive">Primary Inactive</label>
                  <input
                    type="text"
                    id="PrimaryInactive"
                    class="color"
                    value=" rgba(48, 60, 74, 0.54)"
                  /> -->
                  <compact-picker1
                    v-model="primaryInactive"
                    @input="updatePrimaryInactive"
                    :color="primaryInactive"
                    picker="chrome"
                    label="PrimaryInactive"
                  />
                  <p class="t-color-primaryInactive">Primary Inactive color</p>

                  <!-- <label for="Secondary">Secondary</label>
                  <input
                    type="text"
                    id="Secondary"
                    class="color"
                    value="#fefefe"
                  /> -->
                  <compact-picker1
                    v-model="secondary"
                    @input="updateSecondary"
                    :color="secondary"
                    picker="chrome"
                    label="Secondary"
                  />
                  <p class="t-color-secondary">Secondary color</p>

                  <!-- <label for="SecondaryInactive">Secondary Inactive</label>
                  <input
                    type="text"
                    id="SecondaryInactive"
                    class="color"
                    value="rgba(254, 254, 254, 0.54)"
                  /> -->
                  <compact-picker1
                    v-model="secondaryInactive"
                    @input="updateSecondaryInactive"
                    :color="secondaryInactive"
                    picker="chrome"
                    label="Secondary Inactive"
                  />
                  <p class="t-color-secondaryInactive">
                    Secondary Inactive color
                  </p>

                  <!-- <label for="Mainbtn">Main btn</label>
                  <input
                    type="text"
                    id="Mainbtn"
                    class="color"
                    value="#F85053"
                  /> -->

                  <compact-picker1
                    v-model="mainbtn"
                    @input="updateMainbtn"
                    :color="mainbtn"
                    picker="chrome"
                    label="Main btn"
                  />
                  <p class="t-color-mainBtn">Main btn color</p>

                  <!-- <label for="SecondaryBtn">Secondary Btn</label> -->
                  <!-- <input
                    type="text"
                    id="SecondaryBtn"
                    class="color"
                    value="#FCFCFC"
                  /> -->
                  <compact-picker1
                    v-model="secondaryBtn"
                    @input="updateSecondaryBtn"
                    :color="secondaryBtn"
                    picker="chrome"
                    label="Secondary Btn"
                  />
                  <!-- <p class="t-color-secondaryBtn">Secondary Btn color</p>

                  <label for="Snackbarsbtn">Snackbars btn</label>
                  <input
                    type="text"
                    id="Snackbarsbtn"
                    class="color"
                    value="#FF5B5E"
                  /> -->
                  <compact-picker1
                    v-model="snackbarsBtn"
                    @input="updateSnackbarsBtn"
                    :color="snackbarsBtn"
                    picker="chrome"
                    label="Snackbars btn"
                  />
                  <p class="t-color-snackbarBtn">Snackbars btn color</p>

                  <!-- <label for="DisableBtn">Disable Btn</label>
                  <input
                    type="text"
                    id="DisableBtn"
                    class="color"
                    value="#DBDBDB"
                  /> -->
                  <compact-picker1
                    v-model="disableBtn"
                    @input="updateDisableBtn"
                    :color="disableBtn"
                    picker="chrome"
                    label="Disable Btn"
                  />
                  <p class="t-color-disableBtn">Disabled btn color</p>

                  <!-- <label for="Navigationicon">Navigation icon</label>
                  <input
                    type="text"
                    id="Navigationicon"
                    class="color"
                    value="#1d2733"
                  /> -->
                  <compact-picker1
                    v-model="navigationIcon"
                    @input="updateNavigationicon"
                    :color="navigationIcon"
                    picker="chrome"
                    label="Navigation icon"
                  />
                  <p class="t-color-navigationIcon">Disabled btn color</p>

                  <!-- <label for="Divider">Divider</label>
                  <input
                    type="text"
                    id="Divider"
                    class="color"
                    value="rgba(0,0,0,0.13)"
                  /> -->
                  <compact-picker1
                    v-model="divider"
                    @input="updateDivider"
                    :color="divider"
                    picker="chrome"
                    label="Navigation icon"
                  />
                  <p class="t-color-divider">Divider color</p>

                  <!-- <label for="Snackbarsbg">Snackbars bg</label>
                  <input
                    type="text"
                    id="Snackbarsbg"
                    class="color"
                    value="#0E0E0E"
                  /> -->
                  <compact-picker1
                    v-model="snackbarsBg"
                    @input="updateSnackbarsBg"
                    :color="snackbarsBg"
                    picker="chrome"
                    label="Snackbars bg"
                  />
                  <p class="t-color-snackbarsBg">Snackbars bg color</p>

                  <!-- <label for="Iconinactive">Icon inactive</label>
                  <input
                    type="text"
                    id="Iconinactive"
                    class="color"
                    value="var(--Iconinactive)"
                  /> -->
                  <compact-picker1
                    v-model="iconInactive"
                    @input="updateIconInactive"
                    :color="iconInactive"
                    picker="chrome"
                    label="Icon inactive"
                  />
                  <p class="t-color-iconInactive">Icon inactive</p>

                  <!-- <label for="IconinactiveText">Icon inactive Text</label>
                  <input
                    type="text"
                    id="IconinactiveText"
                    class="color"
                    value="rgba(172, 180, 190, 0.54)"
                  /> -->
                  <compact-picker1
                    v-model="iconInactiveText"
                    @input="updateIconInactiveText"
                    :color="iconInactiveText"
                    picker="chrome"
                    label="Icon inactive Text"
                  />
                  <p class="t-color-iconInactiveText">Icon inactive Text</p>

                  <!-- <label for="IconActive">Icon Active</label>
                  <input
                    type="text"
                    id="IconActive"
                    class="color"
                    value="#242F3B"
                  /> -->
                  <compact-picker1
                    v-model="iconActive"
                    @input="updateIconActive"
                    :color="iconActive"
                    picker="chrome"
                    label="Icon Active"
                  />
                  <p class="t-color-iconActive">Icon Active</p>

                  <!-- <label for="Appbartext">Appbar text</label>
                  <input
                    type="text"
                    id="Appbartext"
                    class="color"
                    value="rgb(255, 254, 254)"
                  /> -->
                  <compact-picker1
                    v-model="appbarText"
                    @input="updateAppbarText"
                    :color="appbarText"
                    picker="chrome"
                    label="Appbar Text"
                  />
                  <p class="t-color-appbarText">Appbar text</p>

                  <!-- <label for="AppbartextInactive">Appbar text Inactive</label>
                  <input
                    type="text"
                    id="AppbartextInactive"
                    class="color"
                    value="rgba(255, 254, 254, 0.54)"
                  /> -->
                  <compact-picker1
                    v-model="appbarTextInactive"
                    @input="updateAppbarTextInactive"
                    :color="appbarTextInactive"
                    picker="chrome"
                    label="Appbar Text Inactive"
                  />
                  <p class="t-color-appbarTextInactive">Appbar text Inactive</p>

                  <!-- <label for="Mainbtntext">Main btn text</label>
                  <input
                    type="text"
                    id="Mainbtntext"
                    class="color"
                    value="#fafafa"
                  /> -->
                  <compact-picker1
                    v-model="mainBtnText"
                    @input="updateMainBtnText"
                    :color="mainBtnText"
                    picker="chrome"
                    label="Main btn text"
                  />
                  <p class="t-color-mainBtnText">Main btn text</p>

                  <!-- <label for="Secondarybtntext">Secondary btn text</label>
                  <input
                    type="text"
                    id="Secondarybtntext"
                    class="color"
                    value="#fc5356"
                  /> -->
                  <compact-picker1
                    v-model="secondaryBtnText"
                    @input="updateSecondaryBtnText"
                    :color="secondaryBtnText"
                    picker="chrome"
                    label="Secondary btn text"
                  />
                  <p class="t-color-secondaryBtnText">Secondary btn text</p>

                  <!-- <label for="HeadlineBlack">Headline Black</label>
                  <input
                    type="text"
                    id="HeadlineBlack"
                    class="color"
                    value="#212121"
                  /> -->
                  <compact-picker1
                    v-model="headlineBlack"
                    @input="updateHeadlineBlack"
                    :color="headlineBlack"
                    picker="chrome"
                    label="Headline Black"
                  />
                  <p class="t-color-headlineBlack">Headline Black</p>

                  <!-- <label for="BodygrayA">Bodygray A</label>
                  <input
                    type="text"
                    id="BodygrayA"
                    class="color"
                    value="#818181"
                  /> -->
                  <compact-picker1
                    v-model="bodyGrayA"
                    @input="updateBodygrayA"
                    :color="bodyGrayA"
                    picker="chrome"
                    label="Bodygray A"
                  />
                  <p class="t-color-bodyGrayA">Bodygray A</p>

                  <!-- <label for="BodygrayB">Bodygray B</label> -->
                  <!-- <input
                    type="text"
                    id="BodygrayB"
                    class="color"
                    value="#acacac"
                  /> -->
                  <compact-picker1
                    v-model="bodyGrayB"
                    @input="updateBodyGrayB"
                    :color="bodyGrayB"
                    picker="chrome"
                    label="Bodygray B"
                  />
                  <p class="t-color-bodyGrayB">Bodygray B</p>

                  <!-- <label for="Bodybluegray">Body blue gray</label>
                  <input
                    type="text"
                    id="Bodybluegray"
                    class="color"
                    value="#8698af"
                  /> -->
                  <compact-picker1
                    v-model="bodyBlueGray"
                    @input="updateBodyBlueGray"
                    :color="bodyBlueGray"
                    picker="chrome"
                    label="Body blue gray"
                  />
                  <p class="t-color-bodyBlueGray">Body blue gray</p>

                  <!-- <label for="DisableBtnText">Disable Btn Text</label>
                  <input
                    type="text"
                    id="DisableBtnText"
                    class="color"
                    value="#9a9a9a"
                  /> -->
                  <compact-picker1
                    v-model="disableBtnText"
                    @input="updateDisableBtnText"
                    :color="disableBtnText"
                    picker="chrome"
                    label="Disable Btn Text"
                  />
                  <p class="t-color-disableBtnText">Disable Btn Text</p>

                  <!-- <label for="WhiteHigh">White High</label>
                  <input
                    type="text"
                    id="WhiteHigh"
                    class="color"
                    value="rgba(255,255,255,0.54)"
                  /> -->
                  <compact-picker1
                    v-model="whiteHigh"
                    @input="updateWhiteHigh"
                    :color="whiteHigh"
                    picker="chrome"
                    label="White High"
                  />
                  <p class="t-color-whiteHigh">White High</p>

                  <!-- <label for="WhiteMedium">White Medium</label>
                  <input
                    type="text"
                    id="WhiteMedium"
                    class="color"
                    value="rgba(255,255,255,0.60)"
                  /> -->
                  <compact-picker1
                    v-model="whiteMedium"
                    @input="updateWhiteMedium"
                    :color="whiteMedium"
                    picker="chrome"
                    label="White Medium"
                  />
                  <p class="t-color-whiteMedium">White Medium</p>

                  <!-- <label for="WhiteDisabled">White Disabled</label>
                  <input
                    type="text"
                    id="WhiteDisabled"
                    class="color"
                    value="rgba(255,255,255,0.38)"
                  /> -->
                  <compact-picker1
                    v-model="whiteDisabled"
                    @input="updateWhiteDisabled"
                    :color="whiteDisabled"
                    picker="chrome"
                    label="White Disabled"
                  />
                  <p class="t-color-whiteDisabled">White Disabled</p>

                  <!-- <label for="WhiteBorder">White Border</label>
                  <input
                    type="text"
                    id="WhiteBorder"
                    class="color"
                    value="rgba(255,255,255,0.13)"
                  /> -->
                  <compact-picker1
                    v-model="whiteBorder"
                    @input="updateWhiteBorder"
                    :color="whiteBorder"
                    picker="chrome"
                    label="White Border"
                  />
                  <p class="border-white">White Border</p>

                  <!-- <label for="Textfeildguid">Text feild guid</label>
                  <input
                    type="text"
                    id="Textfeildguid"
                    class="color"
                    value="#acb2b9"
                  /> -->
                  <compact-picker1
                    v-model="textfieldGuid"
                    @input="updateTextfeildguid"
                    :color="textfieldGuid"
                    picker="chrome"
                    label="Text feild guide"
                  />
                  <p class="t-color-textfieldGuid">Text feild guid</p>

                  <!-- <label for="TextfeildguidLine">Text feild guid Line</label>
                  <input
                    type="text"
                    id="TextfeildguidLine"
                    class="color"
                    value="rgba(172, 178, 185,0.70)"
                  /> -->
                  <compact-picker1
                    v-model="textfieldGuidLine"
                    @input="updateTextfeildguidLine"
                    :color="textfieldGuidLine"
                    picker="chrome"
                    label="Text feild guide Line"
                  />
                  <p class="t-color-textfieldGuidLine">Text feild guid Line</p>

                  <!-- <label for="Textfeildactive">Text feild active</label>
                  <input
                    type="text"
                    id="Textfeildactive"
                    class="color"
                    value="#546e7a"
                  /> -->
                  <compact-picker1
                    v-model="textfieldActive"
                    @input="updateTextfeildactive"
                    :color="textfieldActive"
                    picker="chrome"
                    label="Text feild active"
                  />
                  <p class="t-color-textfieldActive">Text feild active</p>

                  <!-- <label for="Textfeilderror">Text feild error</label>
                  <input
                    type="text"
                    id="Textfeilderror"
                    class="color"
                    value="#ff4145"
                  /> -->
                  <compact-picker1
                    v-model="textfieldError"
                    @input="updateTextfeilderror"
                    :color="textfieldError"
                    picker="chrome"
                    label="Text feild error"
                  />
                  <p class="t-color-textfieldError">Text feild error</p>

                  <!-- <label for="Saleline">Sale line</label>
                  <input
                    type="text"
                    id="Saleline"
                    class="color"
                    value="#ee5b5e"
                  /> -->
                  <compact-picker1
                    v-model="saleLine"
                    @input="updateSaleline"
                    :color="saleLine"
                    picker="chrome"
                    label="Sale line"
                  />
                  <p class="t-color-saleLine">Sale Line</p>

                  <!-- <label for="SignGray">Sign Gray</label>
                  <input
                    type="text"
                    id="SignGray"
                    class="color"
                    value="#bdc1c3"
                  /> -->
                  <compact-picker1
                    v-model="signGray"
                    @input="updateSignGray"
                    :color="signGray"
                    picker="chrome"
                    label="Sign Gray"
                  />
                  <p class="t-color-signGray">Sign Gray</p>

                  <!-- <label for="SignRed">Sign Red</label>
                  <input
                    type="text"
                    id="SignRed"
                    class="color"
                    value="#ea8585"
                  /> -->
                  <compact-picker1
                    v-model="signRed"
                    @input="updateSignRed"
                    :color="signRed"
                    picker="chrome"
                    label="Sign Red"
                  />
                  <p class="t-color-signRed">Sign Red</p>

                  <!-- <label for="SignBlue">Sign Blue</label>
                  <input
                    type="text"
                    id="SignBlue"
                    class="color"
                    value="#80aed4"
                  /> -->
                  <compact-picker1
                    v-model="signBlue"
                    @input="updatesignBlue"
                    :color="signBlue"
                    picker="chrome"
                    label="Sign Blue"
                  />
                  <p class="t-color-signBlue">Sign Blue</p>

                  <!-- <label for="ContentsBG">Contents BG</label>
                  <input
                    type="text"
                    id="ContentsBG"
                    class="color"
                    value="#1b232b"
                  /> -->
                  <compact-picker1
                    v-model="contentBg"
                    @input="updateContentsBG"
                    :color="contentBg"
                    picker="chrome"
                    label="Contents BG"
                  />
                  <p class="t-color-contentBg">Contents BG</p>

                  <!-- <label for="ContentVariation">Content Variation</label>
                  <input
                    type="text"
                    id="ContentVariation"
                    class="color"
                    value="#758191"
                  /> -->
                  <compact-picker1
                    v-model="contentVariation"
                    @input="updateContentVariation"
                    :color="contentVariation"
                    picker="chrome"
                    label="Content Variation"
                  />
                  <p class="t-color-contentVariation">Content Variation</p>

                  <!-- <label for="ContentVariationInactive"
                    >Content Variation Inactive</label
                  >
                  <input
                    type="text"
                    id="ContentVariationInactive"
                    class="color"
                    value="rgba(117, 129, 145, 0.54)"
                  /> -->
                  <compact-picker1
                    v-model="contentVariationInactive"
                    @input="updateContentVariationInactive"
                    :color="contentVariationInactive"
                    picker="chrome"
                    label="Content Variation Inactive"
                  />
                  <p class="t-color-contentVariationInactive">
                    Content Variation Inactive
                  </p>

                  <!-- <label for="ContentBlue">Content Blue</label>
                  <input
                    type="text"
                    id="ContentBlue"
                    class="color"
                    value="#76a0d6"
                  /> -->
                  <compact-picker1
                    v-model="contentBlue"
                    @input="updateContentBlue"
                    :color="contentBlue"
                    picker="chrome"
                    label="Content Blue"
                  />
                  <p class="t-color-contentBlue">Content Blue</p>

                  <!-- <label for="ContentBlueMedium">Content Blue Medium</label>
                  <input
                    type="text"
                    id="ContentBlueMedium"
                    class="color"
                    value="rgba(118, 160, 214, 0.60)"
                  /> -->
                  <compact-picker1
                    v-model="contentBlueMidium"
                    @input="updateContentBlueMedium"
                    :color="contentBlueMidium"
                    picker="chrome"
                    label="Content Blue Medium"
                  />
                  <p class="t-color-contentBlueMidium">Content Blue Medium</p>

                  <!-- <label for="ContentBlueInactive">Content Blue Inactive</label>
                  <input
                    type="text"
                    id="ContentBlueInactive"
                    class="color"
                    value="rgba(118, 160, 214, 0.12)"
                  /> -->
                  <compact-picker1
                    v-model="contentBlueInactive"
                    @input="updateContentBlueInactive"
                    :color="contentBlueInactive"
                    picker="chrome"
                    label="Content Blue Inactive"
                  />
                  <p class="t-color-contentBlueInactive">
                    Content Blue Inactive
                  </p>

                  <!-- <label for="ContentRed">Content Red</label>
                  <input
                    type="text"
                    id="ContentRed"
                    class="color"
                    value="#f16d70"
                  /> -->
                  <compact-picker1
                    v-model="contentRed"
                    @input="updateContentRed"
                    :color="contentRed"
                    picker="chrome"
                    label="Content Red"
                  />
                  <p class="t-color-red">Content Red</p>

                  <!-- <label for="ContentRedSelect">Content Red Select</label>
                  <input
                    type="text"
                    id="ContentRedSelect"
                    class="color"
                    value="rgba(241, 109, 112, 0.54)"
                  /> -->
                  <compact-picker1
                    v-model="redSelect"
                    @input="updateContentRedSelect"
                    :color="redSelect"
                    picker="chrome"
                    label="Content Red Select"
                  />
                  <p class="t-color-redSelect">Content Red Select</p>

                  <!-- <label for="Starmark">Star mark</label>
                  <input
                    type="text"
                    id="Starmark"
                    class="color"
                    value="var(--Starmark)"
                  /> -->
                  <compact-picker1
                    v-model="starmark"
                    @input="updateStarmark"
                    :color="starmark"
                    picker="chrome"
                    label="Star mark"
                  />
                  <p class="t-color-starmark">Star mark</p>

                  <!-- <label for="ContentProgressBG">Content Progress BG</label>
                  <input
                    type="text"
                    id="ContentProgressBG"
                    class="color"
                    value="#ffedee"
                  /> -->
                  <compact-picker1
                    v-model="contentProgressBG"
                    @input="updateContentProgressBG"
                    :color="contentProgressBG"
                    picker="chrome"
                    label="Content Progress BG"
                  />
                  <p class="bg-contentProgressBG">Content Progress BG</p>

                  <!-- <label for="ContentText">Content Text</label>
                  <input
                    type="text"
                    id="ContentText"
                    class="color"
                    value="#2a2a2a"
                  /> -->
                  <compact-picker1
                    v-model="contentText"
                    @input="updateContentText"
                    :color="contentText"
                    picker="chrome"
                    label="Content Text"
                  />
                  <p class="t-color-contentText">Content Text</p>

                  <!-- <label for="ContentSubtext">Content Subtext</label>
                  <input
                    type="text"
                    id="ContentSubtext"
                    class="color"
                    value="rgba(42,42,42, 0.6)"
                  /> -->
                  <compact-picker1
                    v-model="contentSubtext"
                    @input="updateContentSubtext"
                    :color="contentSubtext"
                    picker="chrome"
                    label="Content Subtext"
                  />
                  <p class="t-color-contentSubtext">Content Subtext</p>

                  <!-- <label for="DocumentGray">Document Gray</label>
                  <input
                    type="text"
                    id="DocumentGray"
                    class="color"
                    value="#f9f9f9"
                  /> -->
                  <compact-picker1
                    v-model="documentGray"
                    @input="updateDocumentGray"
                    :color="documentGray"
                    picker="chrome"
                    label="Document Gray"
                  />
                  <p class="t-color-documentGray">Document Gray</p>

                  <!-- <label for="FocusBlue">Focus Blue</label>
                  <input
                    type="text"
                    id="FocusBlue"
                    class="color"
                    value="#27bdff"
                  /> -->
                  <compact-picker1
                    v-model="focusBlue"
                    @input="updateFocusBlue"
                    :color="focusBlue"
                    picker="chrome"
                    label="Focus Blue"
                  />
                  <p class="t-color-focusBlue">Focus Blue</p>

                  <compact-picker1
                    v-model="linkBlue"
                    @input="updateLinkBlue"
                    :color="linkBlue"
                    picker="chrome"
                    label="Link Blue"
                  />
                  <p class="t-color-linkBlue">Link Blue</p>

                  <!-- <label for="LinkBG">Link BG</label>
                  <input
                    type="text"
                    id="LinkBG"
                    class="color"
                    value="rgba(96, 228, 255, 0.22)"
                  /> -->
                  <compact-picker1
                    v-model="linkBg"
                    @input="updateLinkBG"
                    :color="linkBg"
                    picker="chrome"
                    label="Link BG"
                  />
                  <p class="t-color-linkBg">Link BG</p>

                  <!-- <label for="QuizBlack">Quiz Black</label>
                  <input
                    type="text"
                    id="QuizBlack"
                    class="color"
                    value="#5a6a7d"
                  /> -->
                  <compact-picker1
                    v-model="quizBlack"
                    @input="updateQuizBlack"
                    :color="quizBlack"
                    picker="chrome"
                    label="Quiz Black"
                  />
                  <p class="t-color-quizBlack">Quiz Black</p>

                  <!-- <label for="QuizBlackInactive">Quiz Black Inactive</label>
                  <input
                    type="text"
                    id="QuizBlackInactive"
                    class="color"
                    value="rgba(90, 106, 125, 0.54)"
                  /> -->
                  <compact-picker1
                    v-model="quizBlackInactive"
                    @input="updateQuizBlackInactive"
                    :color="quizBlackInactive"
                    picker="chrome"
                    label="Quiz Black Inactive"
                  />
                  <p class="t-color-quizBlackInactive">Quiz Black Inactive</p>

              
                  <!-- <compact-picker1
                    v-model="quizBlue"
                    @input="updateQuizBlue"
                    :color="quizBlue"
                    picker="chrome"
                    label="Quiz Blue"
                  />
                  <p class="t-color-quizBlue">Quiz Blue</p> -->

                  <!-- <label for="QuizGray">Quiz Gray</label>
                  <input
                    type="text"
                    id="QuizGray"
                    class="color"
                    value="rgba(113, 127, 143,0.7)"
                  /> -->
                  <compact-picker1
                    v-model="quizGray"
                    @input="updateQuizGray"
                    :color="quizGray"
                    picker="chrome"
                    label="Quiz Gray"
                  />
                  <p class="t-color-quizGray">Quiz Gray</p>

                  <!-- <label for="QuizBluegray">Quiz Blue gray</label>
                  <input
                    type="text"
                    id="QuizBluegray"
                    class="color"
                    value="#d0d8e1"
                  /> -->
                  <compact-picker1
                    v-model="quizBlueGray"
                    @input="updateQuizBluegray"
                    :color="quizBlueGray"
                    picker="chrome"
                    label="Quiz Blue Gray"
                  />
                  <p class="t-color-quizBlueGray">Quiz Blue Gray</p>

                  <!-- <label for="QuizWhite">Quiz White</label>
                  <input
                    type="text"
                    id="QuizWhite"
                    class="color"
                    value="rgba(255,255,255,0.5)"
                  /> -->
                  <compact-picker1
                    v-model="quizWhite"
                    @input="updateQuizWhite"
                    :color="quizWhite"
                    picker="chrome"
                    label="Quiz White"
                  />
                  <p class="t-color-quizWhite">Quiz White</p>

                  <!-- <label for="NotiRed">Noti Red</label>
                  <input
                    type="text"
                    id="NotiRed"
                    class="color"
                    value="#d86c6c"
                  /> -->
                  <compact-picker1
                    v-model="notiRed"
                    @input="updateNotiRed"
                    :color="notiRed"
                    picker="chrome"
                    label="Noti Red"
                  />
                  <p class="t-color-notiRed">Noti Red</p>

                  <!-- <label for="NotiGreen">Noti Green</label>
                  <input
                    type="text"
                    id="NotiGreen"
                    class="color"
                    value="#35929e"
                  /> -->
                  <compact-picker1
                    v-model="notiGreen"
                    @input="updateNotiGreen"
                    :color="notiGreen"
                    picker="chrome"
                    label="Noti Green"
                  />
                  <p class="t-color-notiGreen">Noti Green</p>

                  <!-- <label for="NotiBlue">Noti Blue</label>
                  <input
                    type="text"
                    id="NotiBlue"
                    class="color"
                    value="#658ec7"
                  /> -->
                  <compact-picker1
                    v-model="notiBlue"
                    @input="updateNotiBlue"
                    :color="notiBlue"
                    picker="chrome"
                    label="Noti Blue"
                  />
                  <p class="t-color-notiBlue">Noti Blue</p>

                  <!-- <label for="TagGreen">Tag Green</label>
                  <input
                    type="text"
                    id="TagGreen"
                    class="color"
                    value="#2eb67d"
                  /> -->
                  <compact-picker1
                    v-model="tagGreen"
                    @input="updateTagGreen"
                    :color="tagGreen"
                    picker="chrome"
                    label="Tag Green"
                  />
                  <p class="t-color-tagGreen">Tag Green</p>

                  <!-- <label for="LectureRed">Lecture Red</label>
                  <input
                    type="text"
                    id="LectureRed"
                    class="color"
                    value="#ff847b"
                  /> -->
                  <compact-picker1
                    v-model="lectureRed"
                    @input="updateLectureRed"
                    :color="lectureRed"
                    picker="chrome"
                    label="Lecture Red"
                  />
                  <p class="t-color-lectureRed">Lecture Red</p>

                  <!-- <compact-picker1
                    v-model="lectureRedBg"
                    @input="updateLectureRedBG"
                    :color="lectureRedBg"
                    picker="chrome"
                    label="Lecture Red BG"
                  />
                  <p class="bg-lectureRed">Lecture Red BG</p> -->

                  <!-- <label for="LectureRedBG16">Lecture Red BG16</label>
                  <input
                    type="text"
                    id="LectureRedBG16"
                    class="color"
                    value="rgba(255, 132, 123, 0.16)"
                  /> -->
                  <compact-picker1
                    v-model="lectureRedBG16"
                    @input="updateLectureRedBG16"
                    :color="lectureRedBG16"
                    picker="chrome"
                    label="Lecture Red BG16"
                  />
                  <p class="bg-lectureRedBG16">Lecture Red BG16</p>

                  <!-- <label for="LecturePurple">Lecture Purple</label> -->
                  <!-- <input
                    type="text"
                    id="LecturePurple"
                    class="color"
                    value="#b295e6"
                  /> -->
                  <compact-picker1
                    v-model="lecturePurple"
                    @input="updateLecturePurple"
                    :color="lecturePurple"
                    picker="chrome"
                    label="Lecture Purple"
                  />
                  <p class="t-color-lecturePurple">Lecture Purple</p>

                  <!-- <compact-picker1
                    v-model="lecturePurpleBg"
                    @input="updateLecturePurpleBG"
                    :color="lecturePurpleBg"
                    picker="chrome"
                    label="Lecture Purple BG"
                  />
                  <p class="bg-lecturePurple">Lecture Red BG</p> -->

                  <!-- <label for="LecturePurpleBG16">Lecture Purple BG16</label>
                  <input
                    type="text"
                    id="LecturePurpleBG16"
                    class="color"
                    value=
                    "rgba(178, 149, 230, 0.16)"
                  /> -->
                  <compact-picker1
                    v-model="lecturePurpleBG16"
                    @input="updateLecturePurpleBG16"
                    :color="lecturePurpleBG16"
                    picker="chrome"
                    label="Lecture Purple BG16"
                  />
                  <p class="bg-LecturePurpleBG16">Lecture Purple BG16</p>

                  <!-- <label for="LectureYellow">Lecture Yellow</label>
                  <input
                    type="text"
                    id="LectureYellow"
                    class="color"
                    value="#ffad6e"
                  /> -->
                  <compact-picker1
                    v-model="lectureYellow"
                    @input="updateLectureYellow"
                    :color="lectureYellow"
                    picker="chrome"
                    label="Lecture Yellow"
                  />
                  <p class="t-color-lectureYellow">Lecture Yellow</p>

                  
                  <!-- <compact-picker1
                    v-model="lectureYellowBg"
                    @input="updateLectureYellowBG"
                    :color="lectureYellowBg"
                    picker="chrome"
                    label="Lecture Yellow BG"
                  />
                  <p class="bg-LectureYellow">Lecture Red BG</p> -->

                  <!-- <label for="LectureYellowBG16">Lecture Yellow BG16</label>
                  <input
                    type="text"
                    id="LectureYellowBG16"
                    class="color"
                    value="rgba(255, 173, 110, 0.16)"
                  /> -->
                  <compact-picker1
                    v-model="lectureYellowBG16"
                    @input="updateLectureYellowBG16"
                    :color="lectureYellowBG16"
                    picker="chrome"
                    label="Lecture Yellow BG16"
                  />
                  <p class="bg-LectureYellowBG16">Lecture Yellow BG16</p>

                  <!-- <label for="LectureAqua">Lecture Aqua</label>
                  <input
                    type="text"
                    id="LectureAqua"
                    class="color"
                    value="#70cfc8"
                  /> -->
                  <compact-picker1
                    v-model="lectureAqua"
                    @input="updateLectureAqua"
                    :color="lectureAqua"
                    picker="chrome"
                    label="Lecture Aqua"
                  />
                  <p class="t-color-lectureAqua">Lecture Aqua</p>

                  
                  <!-- <compact-picker1
                    v-model="lectureAquaBg"
                    @input="updateLectureAquaBG"
                    :color="lectureAquaBg"
                    picker="chrome"
                    label="Lecture Red BG"
                  />
                  <p class="bg-lectureAqua">Lecture Red BG</p> -->

                  <compact-picker1
                    v-model="lectureAquaBG16"
                    @input="updateLectureAquaBG16"
                    :color="lectureAquaBG16"
                    picker="chrome"
                    label="Lecture Aqua BG16"
                  />
                  <p class="bg-LectureAquaBG16">Lecture Aqua BG16</p>

                  <!-- <label for="PaymentBlue">Payment Blue</label>
                  <input
                    type="text"
                    id="PaymentBlue"
                    class="color"
                    value="#ebf0f6"
                  /> -->
                  <compact-picker1
                    v-model="paymentBlue"
                    @input="updatePaymentBlue"
                    :color="paymentBlue"
                    picker="chrome"
                    label="Payment Blue"
                  />
                  <p class="t-color-paymentBlue">Payment Blue</p>

                  <!-- <label for="Newnotice">New notice</label>
                  <input
                    type="text"
                    id="Newnotice"
                    class="color"
                    value="#fc6165"
                  /> -->
                  <compact-picker1
                    v-model="newNotice"
                    @input="updateNewnotice"
                    :color="newNotice"
                    picker="chrome"
                    label="New notice"
                  />
                  <p class="t-color-newNotice">New Notice</p>

                  <!-- <label for="Examred">Exam red</label>
                  <input
                    type="text"
                    id="Examred"
                    class="color"
                    value="#eb4d50"
                  /> -->
                  <compact-picker1
                    v-model="examRed"
                    @input="updateExamred"
                    :color="examRed"
                    picker="chrome"
                    label="Exam red"
                  />
                  <p class="t-color-examRed">Exam Red</p>

                  <!-- <label for="ExamRedLine">Exam Red Line</label>
                  <input
                    type="text"
                    id="ExamRedLine"
                    class="color"
                    value="rgba(235, 77, 80, 0.30)"
                  /> -->
                  <compact-picker1
                    v-model="examRedLine"
                    @input="updateExamRedLine"
                    :color="examRedLine"
                    picker="chrome"
                    label="Exam Red Line"
                  />
                  <p class="t-color-examRedLine">Exam Red Line</p>

                  <!-- <label for="Examgreen">Exam green</label>
                  <input
                    type="text"
                    id="Examgreen"
                    class="color"
                    value="#2bac76"
                  /> -->
                  <compact-picker1
                    v-model="examGreen"
                    @input="updateExamgreen"
                    :color="examGreen"
                    picker="chrome"
                    label="Exam green"
                  />
                  <p class="t-color-examGreen">Exam Green</p>

                  <!-- <label for="ExamGreenLine">Exam Green Line</label>
                  <input
                    type="text"
                    id="ExamGreenLine"
                    class="color"
                    value="rgba(43, 172, 118, 0.30)"
                  /> -->
                  <compact-picker1
                    v-model="examGreenLine"
                    @input="updateExamGreenLine"
                    :color="examGreenLine"
                    picker="chrome"
                    label="Exam Green Line"
                  />
                  <p class="t-color-examGreenLine">Exam Green Line</p>

                  <!-- <label for="Examblue">Exam blue</label>
                  <input
                    type="text"
                    id="Examblue"
                    class="color"
                    value="#5b718b"
                  /> -->
                  <compact-picker1
                    v-model="examBlue"
                    @input="updateExamblue"
                    :color="examBlue"
                    picker="chrome"
                    label="Exam blue"
                  />
                  <p class="t-color-examBlue">Exam Blue</p>

                  <!-- <label for="ExamBlueLine">Exam Blue Line</label>
                  <input
                    type="text"
                    id="ExamBlueLine"
                    class="color"
                    value="rgba(91, 113, 139, 0.30)"
                  /> -->
                  <compact-picker1
                    v-model="examBlueLine"
                    @input="updateExamBlueLine"
                    :color="examBlueLine"
                    picker="chrome"
                    label="Exam Blue Line"
                  />
                  <p class="t-color-examBlueLine">Exam Blue Line</p>

                  <!-- <label for="CommentGray">Comment Gray</label>
                  <input
                    type="text"
                    id="CommentGray"
                    class="color"
                    value="var(--WhiteHigh)"
                  /> -->
                  <compact-picker1
                    v-model="commentGray"
                    @input="updateCommentGray"
                    :color="commentGray"
                    picker="chrome"
                    label="Comment Gray"
                  />
                  <p class="t-color-commentGray">Comment Gray</p>

                  <!-- <label for="CommentBlue">Comment Blue</label>
                  <input
                    type="text"
                    id="CommentBlue"
                    class="color"
                    value="#abd4f7"
                  /> -->
                  <compact-picker1
                    v-model="commentBlue"
                    @input="updateCommentBlue"
                    :color="commentBlue"
                    picker="chrome"
                    label="Comment Blue"
                  />
                  <p class="t-color-commentBlue">Comment Blue</p>
                  <!-- <compact-picker1 v-model="colour" :color="colour" picker="chrome" label="Color"/> -->
                  <!-- <compact-picker1 v-model="colour1" :color="colour1" picker="chrome" label="Color"/> -->
                  <!-- <ColourPicker v-model="colour" :color="colour1" picker="chrome" label="Color"/> -->

                  <!-- <sketch-picker
                    @input="updateValue"
                    :value="colors"
                    @ok="onOk"
                    @cancel="onCancel"
                  ></sketch-picker>

                  <compact-picker
                    @input="updateValue"
                    :value="colors"
                  ></compact-picker>

                  <material-picker @input="updateValue" :value="colors" />
                  <chrome-picker @input="updateValue" :value="colors" />
                  <photoshop-picker
                    @input="updateValue"
                    :value="colors"
                    @ok="onOk"
                    @cancel="onCancel"
                  /> -->
                  <!-- <div class="input-group color-picker" ref="colorpicker"><chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" @focus="showPicker()" @click="togglePicker()"/></div> -->
                  <!-- <div class="input-group color-picker" ref="colorpicker">
                    <input
                      type="text"
                      class="form-control"
                      v-model="colorValue"
                      @focus="showPicker()"
                      @input="updateFromInput"
                    />
                    <span class="input-group-addon color-picker-container">
                      <span
                        class="current-color"
                        :style="'background-color: ' + colorValue"
                        @click="togglePicker()"
                      ></span>
                      <chrome-picker
                        :value="colors"
                        @input="updateFromPicker"
                        v-if="displayPicker"
                      />
                    </span>
                  </div>

                  <br />
                  <br />
                  <br />
                  <br /> -->

                  <!-- <div class="input-group color-picker" ref="colorpicker1">
                    <input
                      type="text"
                      class="form-control"
                      v-model="colorValue1"
                      @focus="showPicker1()"
                      @input="updateFromInput1"
                    />
                    <span class="input-group-addon color-picker-container">
                      <span
                        class="current-color"
                        :style="'background-color: ' + colorValue1"
                        @click="togglePicker1()"
                      ></span>
                      <chrome-picker
                        :value="colorValue1"
                        @input="updateFromPicker1"
                        v-if="displayPicker1"
                      />
                    </span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * 이용약관 컴포넌트(terms and use Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import joinApi from "@/api/joinApi.js";
import ColourPicker from "vue-colour-picker";

// import { Sketch } from "vue-color";
// import { Compact } from "vue-color";
// import { Material } from "vue-color";
import { Chrome } from "vue-color";
// import { Photoshop } from "vue-color";

let defaultProps = {
  hex: "#194d33e6",
  hsl: {
    h: 150,
    s: 0.5,
    l: 0.2,
    a: 0.9,
  },
  hsv: {
    h: 150,
    s: 0.66,
    v: 0.3,
    a: 0.9,
  },
  rgba: {
    r: 159,
    g: 96,
    b: 43,
    a: 0.9,
  },
  a: 0.9,
};

export default {
  components: {
    TopAppBar,
    // "sketch-picker": Sketch,
    // "compact-picker": Compact,
    // "material-picker": Material,
    "chrome-picker": Chrome,
    // "photoshop-picker": Photoshop,
    "compact-picker1": ColourPicker,
    "compact-picker2": ColourPicker,
  },
  watch: {
    colorValue(val) {
      if (val) {
        this.updateColors(val);
        this.$emit("input", val);
        //document.body.style.background = val;
      }
    },
  },
  props: ["color"],
  data() {
    return {
      // title: '서비스 이용약관',
      title: this.$t("1220"),
      htmlTermsOfService: null,
      year: "",
      month: "",
      day: "",
      documentWhite: "#ffffff",
      //black: "#000000",
      primary: "#313d4b",
      primaryInactive: "rgba(48, 60, 74, 0.54)",
      secondary: "#fefefe",
      secondaryInactive: "rgba(254, 254, 254, 0.54)",
      mainbtn: "#F85053",
      secondaryBtn: "#FCFCFC",
      snackbarsBtn: "#FF5B5E",
      disableBtn: "#DBDBDB",
      navigationIcon: "#1d2733",
      divider: "rgba(0,0,0,0.13)",
      snackbarsBg: "#0E0E0E",
      iconInactive: "#acb4be",
      iconInactiveText: "rgba(172, 180, 190, 0.54)",
      iconActive: "#242F3B",
      appbarText: "rgb(255, 254, 254)",
      appbarTextInactive: "rgba(255, 254, 254, 0.54)",
      mainBtnText: "#fafafa",
      secondaryBtnText: "#fc5356",
      headlineBlack: "#212121",
      bodyGrayA: "#818181",
      bodyGrayB: "#acacac",
      bodyBlueGray: "#8698af",
      disableBtnText: "#9a9a9a",
      whiteHigh: "rgba(255,255,255,0.54)",
      whiteMedium: "rgba(12,0,0,0.48)",
      whiteDisabled: "rgba(255,255,255,0.38)",
      whiteBorder: "rgba(255,255,255,0.13)",
      textfieldGuid: "#acb2b9",
      textfieldGuidLine: "rgba(172, 178, 185,0.70)",
      textfieldActive: "#546e7a",
      textfieldError: "#ff4145",
      saleLine: "#ee5b5e",
      signGray: "#bdc1c3",
      signRed: "#ea8585",
      signBlue: "#80aed4",
      contentBg: "#1b232b",
      contentVariation: "#758191",
      contentVariationInactive: "rgba(117, 129, 145, 0.54)",
      contentBlue: "#76a0d6",
      contentBlueMidium: "rgba(118, 160, 214, 0.60)",
      contentBlueInactive: "rgba(118, 160, 214, 0.12)",
      contentRed: "#f16d70",
      redSelect: "rgba(241, 109, 112, 0.54)",
      starmark: "#f6bb00",
      contentProgressBG: "#ffedee",
      contentText: "#2a2a2a",
      contentSubtext: "rgba(42,42,42, 0.6)",
      documentGray: "#f9f9f9",
      focusBlue: "#27bdff",
      linkBlue: "#2a7dd1",
      linkBg: "rgba(96, 228, 255, 0.22)",
      quizBlack: "#5a6a7d",
      quizBlackInactive: "rgba(90, 106, 125, 0.54)",
      //quizRed: "#f16d70",
      //quizBlue: "#76a0d6",
      quizGray: "rgba(113, 127, 143,0.7)",
      quizBlueGray: "#d0d8e1",
      quizWhite: "rgba(255,255,255,0.5)",
      notiRed: "#d86c6c",
      notiGreen: "#35929e",
      notiBlue: "#658ec7",
      tagGreen: "#2eb67d",
      lectureRed: "#ff847b",
      //lectureRedBg: "rgba(255, 132, 123, 1)",
      lectureRedBG16: "rgba(255, 132, 123, 0.16)",
      lecturePurple: "#b295e6",
      //lecturePurpleBg: "rgba(178, 149, 230, 1)",
      lecturePurpleBG16: "rgba(178, 149, 230, 0.16)",
      lectureYellow: "#ffad6e",
      //lectureYellowBg: "rgba(255, 173, 110, 1)",
      lectureYellowBG16: "rgba(255, 173, 110, 0.16)",
      lectureAqua: "#70cfc8",
      //lectureAquaBg: "#70cfc8",
      lectureAquaBG16: "rgba(112, 207, 200, 0.16)",
      paymentBlue: "#ebf0f6",
      newNotice: "#fc6165",
      examRed: "#eb4d50",
      examRedLine: "rgba(235, 77, 80, 0.30)",
      examGreen: "#2bac76",
      examGreenLine: "rgba(43, 172, 118, 0.30)",
      examBlue: "#5b718b",
      examBlueLine: "rgba(91, 113, 139, 0.30)",
      commentGray: "#e5e5ea",
      commentBlue: "#abd4f7",
      shadow1: "rgba(0, 0, 0, .26)",
      shadow2: "rgba(0, 0, 0, .20)",
      shadow3: "rgba(0, 0, 0, .13)",
      contentsDim:"rgba(0, 0, 0, .80)",

      root: "",
      colors: defaultProps,
      colorValue: "",
      colorValue1: "#abd4f7",
      displayPicker: false,
      displayPicker1: false,
      colour: "#000000",
      colour1: "#964242",
    };
  },

  mixins: [topAppBarMixin],
  mounted() {
    this.setTopAppBarClosePopup(this.title);
    this.root = document.documentElement;
    //const root = document.querySelector(':root');
    this.setColor(this.color || "#000000");
    // 약관정보 API 호출(call api terms and use)
    joinApi
      .terms()
      .then((response) => {
        // console.log(response.data.data)
        const termsUrl = response.data.data.TERMS_OF_SERVICE;
        const privacyUrl = response.data.data.PRIVACY_STATEMENT;

        joinApi.policyContents(termsUrl, "text").then((response) => {
          this.htmlTermsOfService = response.data;
        });
      })
      .catch((err) => {});

    let params = { type: "TERMS_OF_SERVICE" };
    joinApi
      .termsDate(params)
      .then((response) => {
        if (response.data.data) {
          this.year = this.$moment(response.data.data).format("Y");
          this.month = this.$moment(response.data.data).format("MM");
          this.day = this.$moment(response.data.data).format("DD");
        }
      })
      .catch((err) => {
        console.log("err=>", err);
      });
  },
  methods: {
    setColor(color) {
      this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      if (color.slice(0, 1) == "#") {
        this.colors = {
          hex: color,
        };
      } else if (color.slice(0, 4) == "rgba") {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, "").split(","),
          hex =
            "#" +
            (
              (1 << 24) +
              (parseInt(rgba[0]) << 16) +
              (parseInt(rgba[1]) << 8) +
              parseInt(rgba[2])
            )
              .toString(16)
              .slice(1);
        this.colors = {
          hex: hex,
          a: rgba[3],
        };
      }
    },
    showPicker() {
      document.addEventListener("click", this.documentClick);
      this.displayPicker = true;
    },
    hidePicker() {
      document.removeEventListener("click", this.documentClick);
      this.displayPicker = false;
    },
    hidePicker1() {
      document.removeEventListener("click", this.documentClick1);
      this.displayPicker1 = false;
    },
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker();
    },
    showPicker1() {
      document.addEventListener("click", this.documentClick1);
      this.displayPicker1 = true;
    },
    togglePicker1() {
      this.displayPicker1 ? this.hidePicker1() : this.showPicker1();
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromInput1() {
      this.updateColors(this.colorValue1);
    },
    updateFromPicker(color) {
      this.colors = color;
      if (color.rgba.a == 1) {
        this.colorValue = color.hex;
      } else {
        this.colorValue =
          "rgba(" +
          color.rgba.r +
          ", " +
          color.rgba.g +
          ", " +
          color.rgba.b +
          ", " +
          color.rgba.a +
          ")";
      }
    },
    updateFromPicker1(color) {
      //this.colors = color;
      if (color.rgba.a == 1) {
        this.colorValue1 = color.hex;
      } else {
        this.colorValue1 =
          "rgba(" +
          color.rgba.r +
          ", " +
          color.rgba.g +
          ", " +
          color.rgba.b +
          ", " +
          color.rgba.a +
          ")";
      }
    },
    documentClick(e) {
      var el = this.$refs.colorpicker,
        target = e.target;
      if (el !== target && !el.contains(target)) {
        this.hidePicker();
      }
    },
    documentClick1(e) {
      var el = this.$refs.colorpicker1,
        target = e.target;
      if (el !== target && !el.contains(target)) {
        this.hidePicke1r();
      }
    },
    // applyColor() {
    //   localStorage.setItem('--Primary',this.primary)
    //   let ccc =localStorage.getItem('--Primary')
    //   this.root.style.setProperty('--Primary', ccc);
    //   this.primary = ccc
    //   console.log('root=>ccc',ccc)
    // },
    updateDocumentWhite() {
      localStorage.setItem("--DocumentWhite", this.documentWhite);
      let ccc = localStorage.getItem("--DocumentWhite");
      this.root.style.setProperty("--DocumentWhite", ccc);
      this.documentWhite = ccc;
    },
    updatePrimary() {
      localStorage.setItem("--Primary", this.primary);
      let ccc = localStorage.getItem("--Primary");
      this.root.style.setProperty("--Primary", ccc);
      this.primary = ccc;
      // this.updateColors(this.colorValue);
    },
    // updateBlack(color) {
    //   console.log("color=>", color);
    //   localStorage.setItem("--Black", this.black);
    //   let blackColor = localStorage.getItem("--Black");
    //   this.root.style.setProperty("--Black", blackColor);
    //   this.black = blackColor;
    // },
    
    updatePrimaryInactive() {
      localStorage.setItem("--PrimaryInactive", this.primaryInactive);
      let primaryInactiveColor = localStorage.getItem("--PrimaryInactive");
      this.root.style.setProperty("--PrimaryInactive", primaryInactiveColor);
      this.primaryInactive = primaryInactiveColor;
    },
    updateSecondary() {
      localStorage.setItem("--Secondary", this.secondary);
      let secondaryColor = localStorage.getItem("--Secondary");
      this.root.style.setProperty("--Secondary", secondaryColor);
      this.secondary = secondaryColor;
    },
    updateSecondaryInactive() {
      localStorage.setItem("--SecondaryInactive", this.secondaryInactive);
      let secondaryInactiveColor = localStorage.getItem("--SecondaryInactive");
      this.root.style.setProperty(
        "--SecondaryInactive",
        secondaryInactiveColor
      );
      this.secondaryInactive = secondaryInactiveColor;
    },
    updateMainbtn() {
      localStorage.setItem("--Mainbtn", this.mainbtn);
      let mainbtnColor = localStorage.getItem("--Mainbtn");
      this.root.style.setProperty("--Mainbtn", mainbtnColor);
      this.mainbtn = mainbtnColor;
    },
    updateSecondaryBtn() {
      localStorage.setItem("--SecondaryBtn", this.secondaryBtn);
      let secondaryBtnColor = localStorage.getItem("--SecondaryBtn");
      this.root.style.setProperty("--SecondaryBtn", secondaryBtnColor);
      this.secondaryBtn = secondaryBtnColor;
    },
    updateSnackbarsBtn() {
      localStorage.setItem("--Snackbarsbtn", this.snackbarsBtn);
      let snackbarsBtnColor = localStorage.getItem("--Snackbarsbtn");
      this.root.style.setProperty("--Snackbarsbtn", snackbarsBtnColor);
      this.snackbarsBtn = snackbarsBtnColor;
    },
    updateDisableBtn() {
      localStorage.setItem("--DisableBtn", this.disableBtn);
      let disableBtnColor = localStorage.getItem("--DisableBtn");
      this.root.style.setProperty("--DisableBtn", disableBtnColor);
      this.disableBtn = disableBtnColor;
    },
    updateNavigationicon() {
      localStorage.setItem("--Navigationicon", this.navigationIcon);
      let navigationIconColor = localStorage.getItem("--Navigationicon");
      this.root.style.setProperty("--Navigationicon", navigationIconColor);
      this.navigationIcon = navigationIconColor;
    },
    updateDivider() {
      localStorage.setItem("--Divider", this.divider);
      let dividerColor = localStorage.getItem("--Divider");
      this.root.style.setProperty("--Divider", dividerColor);
      this.divider = dividerColor;
    },
    updateSnackbarsBg() {
      localStorage.setItem("--Snackbarsbg", this.snackbarsBg);
      let snackbarsBgColor = localStorage.getItem("--Snackbarsbg");
      this.root.style.setProperty("--Snackbarsbg", snackbarsBgColor);
      this.snackbarsBg = snackbarsBgColor;
    },
    updateIconInactive() {
      localStorage.setItem("--Iconinactive", this.iconInactive);
      let iconInactiveColor = localStorage.getItem("--Iconinactive");
      this.root.style.setProperty("--Iconinactive", iconInactiveColor);
      this.iconInactive = iconInactiveColor;
    },
    updateIconInactiveText() {
      localStorage.setItem("--IconinactiveText", this.iconInactiveText);
      let iconInactiveTextColor = localStorage.getItem("--IconinactiveText");
      this.root.style.setProperty("--IconinactiveText", iconInactiveTextColor);
      this.iconInactiveText = iconInactiveTextColor;
    },
    updateIconActive() {
      localStorage.setItem("--IconActive", this.iconActive);
      let iconActiveColor = localStorage.getItem("--IconActive");
      this.root.style.setProperty("--IconActive", iconActiveColor);
      this.iconActive = iconActiveColor;
    },
    updateAppbarText() {
      localStorage.setItem("--Appbartext", this.appbarText);
      let appbarTextColor = localStorage.getItem("--Appbartext");
      this.root.style.setProperty("--Appbartext", appbarTextColor);
      this.appbarText = appbarTextColor;
    },
    updateAppbarTextInactive() {
      localStorage.setItem("--AppbartextInactive", this.appbarTextInactive);
      let appbarTextInactiveColor = localStorage.getItem(
        "--AppbartextInactive"
      );
      this.root.style.setProperty(
        "--AppbartextInactive",
        appbarTextInactiveColor
      );
      this.appbarTextInactive = appbarTextInactiveColor;
    },
    updateMainBtnText() {
      localStorage.setItem("--Mainbtntext", this.mainBtnText);
      let mainBtnTextColor = localStorage.getItem("--Mainbtntext");
      this.root.style.setProperty("--Mainbtntext", mainBtnTextColor);
      this.mainBtnText = mainBtnTextColor;
    },
    updateSecondaryBtnText() {
      localStorage.setItem("--Secondarybtntext", this.secondaryBtnText);
      let secondaryBtnTextColor = localStorage.getItem("--Secondarybtntext");
      this.root.style.setProperty("--Secondarybtntext", secondaryBtnTextColor);
      this.secondaryBtnText = secondaryBtnTextColor;
    },
    updateHeadlineBlack() {
      localStorage.setItem("--HeadlineBlack", this.headlineBlack);
      let headlineBlackColor = localStorage.getItem("--HeadlineBlack");
      this.root.style.setProperty("--HeadlineBlack", headlineBlackColor);
      this.headlineBlack = headlineBlackColor;
    },
    updateBodygrayA() {
      localStorage.setItem("--BodygrayA", this.bodyGrayA);
      let bodyGrayAColor = localStorage.getItem("--BodygrayA");
      this.root.style.setProperty("--BodygrayA", bodyGrayAColor);
      this.bodyGrayA = bodyGrayAColor;
    },
    updateBodyGrayB() {
      localStorage.setItem("--BodygrayB", this.bodyGrayB);
      let bodyGrayBColor = localStorage.getItem("--BodygrayB");
      this.root.style.setProperty("--BodygrayB", bodyGrayBColor);
      this.bodyGrayB = bodyGrayBColor;
    },
    updateBodyBlueGray() {
      localStorage.setItem("--Bodybluegray", this.bodyBlueGray);
      let bodyBlueGraykColor = localStorage.getItem("--Bodybluegray");
      this.root.style.setProperty("--Bodybluegray", bodyBlueGraykColor);
      this.bodyBlueGray = bodyBlueGraykColor;
    },
    updateDisableBtnText() {
      localStorage.setItem("--DisableBtnText", this.disableBtnText);
      let disableBtnTextColor = localStorage.getItem("--DisableBtnText");
      this.root.style.setProperty("--DisableBtnText", disableBtnTextColor);
      this.disableBtnText = disableBtnTextColor;
    },
    updateWhiteHigh() {
      localStorage.setItem("--WhiteHigh", this.whiteHigh);
      let whiteHighColor = localStorage.getItem("--WhiteHigh");
      this.root.style.setProperty("--WhiteHigh", whiteHighColor);
      this.whiteHigh = whiteHighColor;
    },
    updateWhiteMedium() {
      localStorage.setItem("--WhiteMedium", this.whiteMedium);
      let whiteMediumColor = localStorage.getItem("--WhiteMedium");
      this.root.style.setProperty("--WhiteMedium", whiteMediumColor);
      this.whiteMedium = whiteMediumColor;
    },
    updateWhiteDisabled() {
      localStorage.setItem("--WhiteDisabled", this.whiteDisabled);
      let whiteDisabledColor = localStorage.getItem("--WhiteDisabled");
      this.root.style.setProperty("--WhiteDisabled", whiteDisabledColor);
      this.whiteDisabled = whiteDisabledColor;
    },
    updateWhiteBorder() {
      localStorage.setItem("--WhiteBorder", this.whiteBorder);
      let whiteBorderColor = localStorage.getItem("--WhiteBorder");
      this.root.style.setProperty("--WhiteBorder", whiteBorderColor);
      this.whiteBorder = whiteBorderColor;
    },
    updateTextfeildguid() {
      localStorage.setItem("--Textfeildguid", this.textfieldGuid);
      let textfieldGuidColor = localStorage.getItem("--Textfeildguid");
      this.root.style.setProperty("--Textfeildguid", textfieldGuidColor);
      this.textfieldGuid = textfieldGuidColor;
    },
    updateTextfeildguidLine() {
      localStorage.setItem("--TextfeildguidLine", this.textfieldGuidLine);
      let textfieldGuidLineColor = localStorage.getItem("--TextfeildguidLine");
      this.root.style.setProperty(
        "--TextfeildguidLine",
        textfieldGuidLineColor
      );
      this.textfieldGuidLine = textfieldGuidLineColor;
    },
    updateTextfeildactive() {
      localStorage.setItem("--Textfeildactive", this.textfieldActive);
      let textfieldActiveColor = localStorage.getItem("--Textfeildactive");
      this.root.style.setProperty("--Textfeildactive", textfieldActiveColor);
      this.textfieldActive = textfieldActiveColor;
    },
    updateTextfeilderror() {
      localStorage.setItem("--Textfeilderror", this.textfieldError);
      let textfieldErrorColor = localStorage.getItem("--Textfeilderror");
      this.root.style.setProperty("--Textfeilderror", textfieldErrorColor);
      this.textfieldError = textfieldErrorColor;
    },
    updateSaleline() {
      localStorage.setItem("--Saleline", this.saleLine);
      let saleLineColor = localStorage.getItem("--Saleline");
      this.root.style.setProperty("--Saleline", saleLineColor);
      this.saleLine = saleLineColor;
    },
    updateSignGray() {
      localStorage.setItem("--SignGray", this.signGray);
      let signGrayColor = localStorage.getItem("--SignGray");
      this.root.style.setProperty("--SignGray", signGrayColor);
      this.signGray = signGrayColor;
    },
    updateSignRed() {
      localStorage.setItem("--SignRed", this.signRed);
      let signRedColor = localStorage.getItem("--SignRed");
      this.root.style.setProperty("--SignRed", signRedColor);
      this.signRed = signRedColor;
    },
    updatesignBlue() {
      localStorage.setItem("--SignBlue", this.signBlue);
      let signBlueColor = localStorage.getItem("--SignBlue");
      this.root.style.setProperty("--SignBlue", signBlueColor);
      this.signBlue = signBlueColor;
    },
    updateContentsBG() {
      localStorage.setItem("--ContentsBG", this.contentBg);
      let contentBgColor = localStorage.getItem("--ContentsBG");
      this.root.style.setProperty("--ContentsBG", contentBgColor);
      this.saleLine = contentBgColor;
    },
    updateContentVariation() {
      localStorage.setItem("--ContentVariation", this.contentVariation);
      let contentVariationColor = localStorage.getItem("--ContentVariation");
      this.root.style.setProperty("--ContentVariation", contentVariationColor);
      this.contentVariation = contentVariationColor;
    },
    updateContentVariationInactive() {
      localStorage.setItem(
        "--ContentVariationInactive",
        this.contentVariationInactive
      );
      let contentVariationInactiveColor = localStorage.getItem(
        "--ContentVariationInactive"
      );
      this.root.style.setProperty(
        "--ContentVariationInactive",
        contentVariationInactiveColor
      );
      this.contentVariationInactive = contentVariationInactiveColor;
    },
    updateContentBlue() {
      localStorage.setItem("--ContentBlue", this.contentBlue);
      let contentBlueColor = localStorage.getItem("--ContentBlue");
      this.root.style.setProperty("--ContentBlue", contentBlueColor);
      this.contentBlue = contentBlueColor;
    },
    updateContentBlueMedium() {
      localStorage.setItem("--ContentBlueMedium", this.contentBlueMidium);
      let contentBlueMidiumColor = localStorage.getItem("--ContentBlueMedium");
      this.root.style.setProperty(
        "--ContentBlueMedium",
        contentBlueMidiumColor
      );
      this.contentBlueMidium = contentBlueMidiumColor;
    },
    updateContentBlueInactive() {
      localStorage.setItem("--ContentBlueInactive", this.contentBlueInactive);
      let contentBlueInactiveColor = localStorage.getItem(
        "--ContentBlueInactive"
      );
      this.root.style.setProperty(
        "--ContentBlueInactive",
        contentBlueInactiveColor
      );
      this.contentBlueInactive = contentBlueInactiveColor;
    },
    updateContentRed() {
      localStorage.setItem("--ContentRed", this.redSelect);
      let redSelectColor = localStorage.getItem("--ContentRed");
      this.root.style.setProperty("--ContentRed", redSelectColor);
      this.redSelect = redSelectColor;
    },
    updateContentRedSelect() {
      localStorage.setItem("--ContentRedSelect", this.redSelect);
      let redContentRedSelectColor = localStorage.getItem("--ContentRedSelect");
      this.root.style.setProperty(
        "--ContentRedSelect",
        redContentRedSelectColor
      );
      this.redSelect = redContentRedSelectColor;
    },
    updateStarmark() {
      localStorage.setItem("--Starmark", this.starmark);
      let starmarkColor = localStorage.getItem("--Starmark");
      this.root.style.setProperty("--Starmark", starmarkColor);
      this.starmark = starmarkColor;
    },
    updateContentProgressBG() {
      localStorage.setItem("--ContentProgressBG", this.contentProgressBG);
      let contentProgressBGColor = localStorage.getItem("--ContentProgressBG");
      this.root.style.setProperty(
        "--ContentProgressBG",
        contentProgressBGColor
      );
      this.contentProgressBG = contentProgressBGColor;
    },
    updateContentText() {
      localStorage.setItem("--ContentText", this.contentText);
      let contentTextColor = localStorage.getItem("--ContentText");
      this.root.style.setProperty("--ContentText", contentTextColor);
      this.contentText = contentTextColor;
    },
    updateContentSubtext() {
      localStorage.setItem("--ContentSubtext", this.contentSubtext);
      let contentSubtextColor = localStorage.getItem("--ContentSubtext");
      this.root.style.setProperty("--ContentSubtext", contentSubtextColor);
      this.contentSubtext = contentSubtextColor;
    },
    updateDocumentGray() {
      localStorage.setItem("--DocumentGray", this.documentGray);
      let documentGrayColor = localStorage.getItem("--DocumentGray");
      this.root.style.setProperty("--DocumentGray", documentGrayColor);
      this.documentGray = documentGrayColor;
    },
    updateFocusBlue() {
      localStorage.setItem("--FocusBlue", this.focusBlue);
      let focusBlueColor = localStorage.getItem("--FocusBlue");
      this.root.style.setProperty("--FocusBlue", focusBlueColor);
      this.focusBlue = focusBlueColor;
    },
    updateLinkBlue() {
      localStorage.setItem("--LinkBlue", this.linkBlue);
      let linkBlueColor = localStorage.getItem("--LinkBlue");
      this.root.style.setProperty("--LinkBlue", linkBlueColor);
      this.linkBlue = linkBlueColor;
    },
    updateLinkBG() {
      localStorage.setItem("--LinkBG", this.linkBg);
      let linkBgColor = localStorage.getItem("--LinkBG");
      this.root.style.setProperty("--LinkBG", linkBgColor);
      this.linkBg = linkBgColor;
    },
    updateQuizBlack() {
      localStorage.setItem("--QuizBlack", this.quizBlack);
      let quizBlackColor = localStorage.getItem("--QuizBlack");
      this.root.style.setProperty("--QuizBlack", quizBlackColor);
      this.quizBlack = quizBlackColor;
    },
    updateQuizBlackInactive() {
      localStorage.setItem("--QuizBlackInactive", this.quizBlackInactive);
      let quizBlackInactiveColor = localStorage.getItem("--QuizBlackInactive");
      this.root.style.setProperty(
        "--QuizBlackInactive",
        quizBlackInactiveColor
      );
      this.quizBlackInactive = quizBlackInactiveColor;
    },
    // updateQuizRed() {
    //   localStorage.setItem("--QuizRed", this.quizRed);
    //   let quizRedColor = localStorage.getItem("--QuizRed");
    //   this.root.style.setProperty("--QuizRed", quizRedColor);
    //   this.quizRed = quizRedColor;
    // },
    // updateQuizBlue() {
    //   localStorage.setItem("--QuizBlue", this.quizBlue);
    //   let quizBlueColor = localStorage.getItem("--QuizBlue");
    //   this.root.style.setProperty("--QuizBlue", quizBlueColor);
    //   this.quizBlue = quizBlueColor;
    // },
    updateQuizGray() {
      localStorage.setItem("--QuizGray", this.quizGray);
      let quizGrayColor = localStorage.getItem("--QuizGray");
      this.root.style.setProperty("--QuizGray", quizGrayColor);
      this.quizGray = quizGrayColor;
    },
    updateQuizBluegray() {
      localStorage.setItem("--QuizBluegray", this.quizBlueGray);
      let quizBlueGrayColor = localStorage.getItem("--QuizBluegray");
      this.root.style.setProperty("--QuizBluegray", quizBlueGrayColor);
      this.quizBlueGray = quizBlueGrayColor;
    },
    updateQuizWhite() {
      localStorage.setItem("--QuizWhite", this.quizWhite);
      let quizWhiteColor = localStorage.getItem("--QuizWhite");
      this.root.style.setProperty("--QuizWhite", quizWhiteColor);
      this.quizWhite = quizWhiteColor;
    },
    updateNotiRed() {
      localStorage.setItem("--NotiRed", this.notiRed);
      let notiRedColor = localStorage.getItem("--NotiRed");
      this.root.style.setProperty("--NotiRed", notiRedColor);
      this.notiRed = notiRedColor;
    },
    updateNotiGreen() {
      localStorage.setItem("--NotiGreen", this.notiGreen);
      let notiGreenColor = localStorage.getItem("--NotiGreen");
      this.root.style.setProperty("--NotiGreen", notiGreenColor);
      this.notiGreen = notiGreenColor;
    },
    updateNotiBlue() {
      localStorage.setItem("--NotiBlue", this.notiBlue);
      let notiBlueColor = localStorage.getItem("--NotiBlue");
      this.root.style.setProperty("--NotiBlue", notiBlueColor);
      this.notiBlue = notiBlueColor;
    },
    updateTagGreen() {
      localStorage.setItem("--TagGreen", this.tagGreen);
      let tagGreenColor = localStorage.getItem("--TagGreen");
      this.root.style.setProperty("--TagGreen", tagGreenColor);
      this.tagGreen = tagGreenColor;
    },
    updateLectureRed() {
      localStorage.setItem("--LectureRed", this.lectureRed);
      let lectureRedColor = localStorage.getItem("--LectureRed");
      this.root.style.setProperty("--LectureRed", lectureRedColor);
      this.lectureRed = lectureRedColor;
    },
    // updateLectureRedBG() {
    //   localStorage.setItem("--LectureRedBG", this.lectureRedBg);
    //   let lectureRedBgColor = localStorage.getItem("--LectureRedBG");
    //   this.root.style.setProperty("--LectureRedBG", lectureRedBgColor);
    //   this.lectureRedBg = lectureRedBgColor;
    // },
    updateLectureRedBG16() {
      localStorage.setItem("--LectureRedBG16", this.lectureRedBG16);
      let lectureRedBG16Color = localStorage.getItem("--LectureRedBG16");
      this.root.style.setProperty("--LectureRedBG16", lectureRedBG16Color);
      this.lectureRedBG16 = lectureRedBG16Color;
    },
    updateLecturePurple() {
      localStorage.setItem("--LecturePurple", this.lecturePurple);
      let lecturePurpleColor = localStorage.getItem("--LecturePurple");
      this.root.style.setProperty("--LecturePurple", lecturePurpleColor);
      this.lecturePurple = lecturePurpleColor;
    },
    // updateLecturePurpleBG() {
    //   localStorage.setItem("--LecturePurpleBG", this.lecturePurpleBg);
    //   let lecturePurpleBgColor = localStorage.getItem("--LecturePurpleBG");
    //   this.root.style.setProperty("--LecturePurpleBG", lecturePurpleBgColor);
    //   this.lecturePurpleBg = lecturePurpleBgColor;
    // },
    updateLecturePurpleBG16() {
      localStorage.setItem("--LecturePurpleBG16", this.lecturePurpleBG16);
      let lecturePurpleBG16Color = localStorage.getItem("--LecturePurpleBG16");
      this.root.style.setProperty(
        "--LecturePurpleBG16",
        lecturePurpleBG16Color
      );
      this.lecturePurpleBG16 = lecturePurpleBG16Color;
    },
    updateLectureYellow() {
      localStorage.setItem("--LectureYellow", this.lectureYellow);
      let lectureYellowColor = localStorage.getItem("--LectureYellow");
      this.root.style.setProperty("--LectureYellow", lectureYellowColor);
      this.lectureYellow = lectureYellowColor;
    },
    // updateLectureYellowBG() {
    //   localStorage.setItem("--LectureYellowBG", this.lectureYellowBg);
    //   let lectureYellowBgColor = localStorage.getItem("--LectureYellowBG");
    //   this.root.style.setProperty("--LectureYellowBG", lectureYellowBgColor);
    //   this.lectureYellowBg = lectureYellowBgColor;
    // },
    updateLectureYellowBG16() {
      localStorage.setItem("--LectureYellowBG16", this.lectureYellowBG16);
      let lectureYellowBG16Color = localStorage.getItem("--LectureYellowBG16");
      this.root.style.setProperty(
        "--LectureYellowBG16",
        lectureYellowBG16Color
      );
      this.lectureYellowBG16 = lectureYellowBG16Color;
    },
    updateLectureAqua() {
      localStorage.setItem("--LectureAqua", this.lectureAqua);
      let lectureAquaColor = localStorage.getItem("--LectureAqua");
      this.root.style.setProperty("--LectureAqua", lectureAquaColor);
      this.lectureAqua = lectureAquaColor;
    },
    // updateLectureAquaBG() {
    //   localStorage.setItem("--LectureAquaBG", this.lectureAquaBg);
    //   let lectureAquaBgColor = localStorage.getItem("--LectureAquaBG");
    //   this.root.style.setProperty("--LectureAquaBG", lectureAquaBgColor);
    //   this.lectureAquaBg = lectureAquaBgColor;
    // },
    updateLectureAquaBG16() {
      localStorage.setItem("--LectureAquaBG16", this.lectureAquaBG16);
      let lectureAquaBG16Color = localStorage.getItem("--LectureAquaBG16");
      this.root.style.setProperty("--LectureAquaBG16", lectureAquaBG16Color);
      this.lectureAquaBG16 = lectureAquaBG16Color;
    },
    updatePaymentBlue() {
      localStorage.setItem("--PaymentBlue", this.paymentBlue);
      let paymentBlueColor = localStorage.getItem("--PaymentBlue");
      this.root.style.setProperty("--PaymentBlue", paymentBlueColor);
      this.paymentBlue = paymentBlueColor;
    },
    updateNewnotice() {
      localStorage.setItem("--Newnotice", this.newNotice);
      let newNoticeColor = localStorage.getItem("--Newnotice");
      this.root.style.setProperty("--Newnotice", newNoticeColor);
      this.newNotice = newNoticeColor;
    },
    updateExamred() {
      localStorage.setItem("--Examred", this.examRed);
      let examRedColor = localStorage.getItem("--Examred");
      this.root.style.setProperty("--Examred", examRedColor);
      this.examRed = examRedColor;
    },
    updateExamRedLine() {
      localStorage.setItem("--ExamRedLine", this.examRedLine);
      let examRedLineColor = localStorage.getItem("--ExamRedLine");
      this.root.style.setProperty("--ExamRedLine", examRedLineColor);
      this.examRedLine = examRedLineColor;
    },
    updateExamgreen() {
      localStorage.setItem("--Examgreen", this.examGreen);
      let examGreenColor = localStorage.getItem("--Examgreen");
      this.root.style.setProperty("--Examgreen", examGreenColor);
      this.examGreen = examGreenColor;
    },
    updateExamGreenLine() {
      localStorage.setItem("--ExamGreenLine", this.examGreenLine);
      let examGreenLineColor = localStorage.getItem("--ExamGreenLine");
      this.root.style.setProperty("--ExamGreenLine", examGreenLineColor);
      this.examGreenLine = examGreenLineColor;
    },
    updateExamblue() {
      localStorage.setItem("--Examblue", this.examBlue);
      let examBlueColor = localStorage.getItem("--Examblue");
      this.root.style.setProperty("--Examblue", examBlueColor);
      this.examBlue = examBlueColor;
    },
    updateExamBlueLine() {
      localStorage.setItem("--ExamBlueLine", this.examBlueLine);
      let examBlueLineColor = localStorage.getItem("--ExamBlueLine");
      this.root.style.setProperty("--ExamBlueLine", examBlueLineColor);
      this.examBlueLine = examBlueLineColor;
    },
    updateCommentGray() {
      localStorage.setItem("--CommentGray", this.commentGray);
      let commentGrayColor = localStorage.getItem("--CommentGray");
      this.root.style.setProperty("--CommentGray", commentGrayColor);
      this.commentGray = commentGrayColor;
    },
    updateCommentBlue() {
      localStorage.setItem("--CommentBlue", this.commentBlue);
      let commentBlueColor = localStorage.getItem("--CommentBlue");
      this.root.style.setProperty("--CommentBlue", commentBlueColor);
      this.commentBlue = commentBlueColor;
    },
    updateShadow1() {
      localStorage.setItem("--Shadow1", this.shadow1);
      let shadow1Color = localStorage.getItem("--Shadow1");
      this.root.style.setProperty("--Shadow1", shadow1Color);
      this.shadow1 = shadow1Color;
    },
    updateShadow2() {
      localStorage.setItem("--Shadow2", this.shadow2);
      let shadow2Color = localStorage.getItem("--Shadow2");
      this.root.style.setProperty("--Shadow2", shadow2Color);
      this.shadow2 = shadow2Color;
    },
    updateShadow3() {
      localStorage.setItem("--Shadow3", this.shadow3);
      let shadow3Color = localStorage.getItem("--Shadow3");
      this.root.style.setProperty("--Shadow3", shadow3Color);
      this.shadow3 = shadow3Color;
    },
    updateContentsDim() {
      localStorage.setItem("--ContentsDim", this.contentsDim);
      let contentsDimColor = localStorage.getItem("--ContentsDim");
      this.root.style.setProperty("--ContentsDim", contentsDimColor);
      this.contentsDim = contentsDimColor;
    },
    // onOk() {
    //   console.log("ok");
    // },
    // onCancel() {
    //   console.log("cancel");
    // },
    // updateValue(value) {
    //   this.colors = value;
    // },
  },
};
</script>

<style scoped>
.vc-chrome {
  left: 0;
}
html[dir="rtl"] .vc-chrome {
  right: 0;
}
.form-control {
  width: 100%;
  border: 1px solid #000;
}
span.current-color {
    border: 1px solid !important;
}
.color-picker-container .current-color {
  border: 1px solid #000 !important;
  width: 40px;
  height: 40px;
}
input.color-input {
	border: 1px solid !important;
}
</style>
